import React, { useState, useEffect } from 'react'
import Layout from '../../layouts/Layout'
import { useSelector } from "react-redux";
import Swal from 'sweetalert2';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FaStarOfLife } from 'react-icons/fa';
import Loader from '../components/Loader';
import { updateShippingAPI, getShippingAPI } from '../../services/api/ShippingAPI';

const EditShippingMethod = () => {
    const { id } = useParams();
    const user = useSelector((state) => state.LoginReducer.authData);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const token = user.data.token;

    const validationSchema = Yup.object({
        name: Yup.string()
            .min(3, 'Name must be at least 3 characters long')
            .required('Name is required'),
        description: Yup.string()
            .required('Description is required'),
        tax_status: Yup.string()
            .required('Tax status is required')
            .oneOf(['Taxable', 'None'], 'Invalid tax status'),
        tax_included: Yup.string()
            .required('Tax included in shipping cost is required'),
        free_shipping_requires: Yup.string()
            .required('Free shipping is required'),
        shipping_threshold: Yup.string()
            .required('Free shipping threshold is required'),
        shipping_label: Yup.string()
                .required('Free Shipping Label is required'),
        rules_calculation: Yup.string()
            .required('Rules calculation is required'),
        cart_calculation: Yup.string()
            .required('Cart calculation is required'),
        // visibility: Yup.boolean()
        //     .typeError('Visibility must be a boolean value')
        //     .required('Visibility is required')
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            description: '',
            tax_status: '',
            tax_included: '',
            free_shipping_requires: '',
            shipping_threshold: '',
            shipping_label: '',
            rules_calculation: '',
            cart_calculation: '',
            visibility: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {            
            setLoading(true);
            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('description', values.description);
            formData.append('tax_status', values.tax_status);
            formData.append('tax_included', values.tax_included);
            formData.append('free_shipping_requires', values.free_shipping_requires);
            formData.append('shipping_threshold', values.shipping_threshold);
            formData.append('shipping_label', values.shipping_label);
            formData.append('rules_calculation', values.rules_calculation);
            formData.append('cart_calculation', values.cart_calculation);
            formData.append('visibility', values.visibility);
            await updateShippingMethod(formData);
        },
    });

    useEffect(() => {
        const fetchShippingMethod = async () => {
            try {
                const data = await getShippingAPI(id, token);
                if (data === null) {
                    navigate('/404');
                } else {
                    formik.setValues({
                        name: data.name,
                        description: data.description,
                        tax_status: data.tax_status,
                        tax_included: data.tax_included,
                        free_shipping_requires: data.free_shipping_requires,
                        shipping_threshold: data.free_shipping_threshold,
                        shipping_label: data.free_shipping_label,
                        rules_calculation: data.rules_calculation,
                        cart_calculation: data.cart_calculation,
                        visibility: data.visible_to_logged_in_only,
                    });
                }                  
                
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Could not fetch blog data.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
            }
        };

        fetchShippingMethod();
    }, [id]);

    const updateShippingMethod = async (formData) => {
        try {
            const data = await updateShippingAPI(formData, id, token);
            setLoading(false);
            if (data.status) {
                Swal.fire({
                    title: 'Shipping Method Updated!',
                    text: 'The Shipping Method has been Updated successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK',
                }).then(() => {
                    navigate('/shippings');
                });
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: 'Error!',
                text: 'Something went wrong please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <Layout title="Edit Shipping Method">
            <div className="container table-container">
                <form onSubmit={formik.handleSubmit}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="name">Name <FaStarOfLife className='text-danger' /></label>
                                    <input type="text" className="form-control mt-1" name="name" id="name" placeholder="Enter name" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.name} />
                                </div>
                                {formik.touched.name && formik.errors.name ? (<label className="text-danger">{formik.errors.name}</label>) : null}
                            </div>
                            <div className="col-md-12 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="description">Description <FaStarOfLife className='text-danger' /></label>
                                    <textarea className="form-control mt-1" rows={3} name="description" id="description" placeholder='Description' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.description}>{formik.values.description}</textarea>
                                </div>
                                {formik.touched.description && formik.errors.description ? (<label className="text-danger">{formik.errors.description}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="tax_status">Tax Status <FaStarOfLife className='text-danger' /></label>
                                    <select className="form-control mt-1" name='tax_status' id='tax_status' value={formik.values.tax_status} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                        <option value="">Select Option</option>
                                        <option value="Taxable">Taxable</option>
                                        <option value="None">None</option>
                                    </select>
                                </div>
                                {formik.touched.tax_status && formik.errors.tax_status ? (<label className="text-danger">{formik.errors.tax_status}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="tax_included">Tax included in shipping cost <FaStarOfLife className='text-danger' /></label>
                                    <select className="form-control mt-1" name='tax_included' id='tax_included' value={formik.values.tax_included} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                        <option value="">Select Option</option>
                                        <option value={1}>Yes, shipping cost inclusive of tax</option>
                                        <option value={0}>No, shipping cost exclusive of tax</option>
                                    </select>
                                </div>
                                {formik.touched.tax_included && formik.errors.tax_included ? (<label className="text-danger">{formik.errors.tax_included}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="free_shipping_requires">Free Shipping Requires<FaStarOfLife className='text-danger' /></label>
                                    <select className="form-control mt-1" name='free_shipping_requires' id='free_shipping_requires' value={formik.values.free_shipping_requires} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                        <option value="">Select Option</option>
                                        <option value="order_amount">Minimum item quantity (PRO)</option>
                                        <option value="item_quantity" disabled>Minimum item quantity (PRO)</option>
                                        <option value="coupon" disabled>Free shipping coupon (PRO)</option>
                                        <option value="order_amount_or_coupon" disabled>Free shipping coupon or minimum order amount (PRO) </option>
                                        <option value="order_amount_and_coupon" disabled>Free shipping coupon and minimum order amount (PRO)</option>
                                    </select>
                                </div>
                                {formik.touched.free_shipping_requires && formik.errors.free_shipping_requires ? (<label className="text-danger">{formik.errors.free_shipping_requires}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="shipping_threshold">Free shipping threshold <FaStarOfLife className='text-danger' /></label>
                                    <input type="text" className="form-control mt-1" name="shipping_threshold" id="shipping_threshold" placeholder="Enter Free shipping threshold" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.shipping_threshold || 0.00} />
                                </div>
                                {formik.touched.shipping_threshold && formik.errors.shipping_threshold ? (<label className="text-danger">{formik.errors.shipping_threshold}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="shipping_label">Free Shipping Label <FaStarOfLife className='text-danger' /></label>
                                    <input type="text" className="form-control mt-1" name="shipping_label" id="shipping_label" placeholder="Enter Free Shipping Label" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.shipping_label || ''} />
                                </div>
                                {formik.touched.shipping_label && formik.errors.shipping_label ? (<label className="text-danger">{formik.errors.shipping_label}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="rules_calculation">Rules Calculation <FaStarOfLife className='text-danger' /></label>
                                    <select className="form-control mt-1" name='rules_calculation' id='rules_calculation' value={formik.values.rules_calculation} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                        <option value="">Select Option</option>
                                        <option value="sum" selected="selected">Sum</option>
                                    </select>
                                </div>
                                {formik.touched.rules_calculation && formik.errors.rules_calculation ? (<label className="text-danger">{formik.errors.rules_calculation}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="cart_calculation">Cart Calculation <FaStarOfLife className='text-danger' /></label>
                                    <select className="form-control mt-1" name='cart_calculation' id='cart_calculation' value={formik.values.cart_calculation} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                        <option value="">Select Option</option>
                                        <option value="cart_total">Cart value</option>
                                        <option value="package_value">Package value</option>
                                    </select>
                                </div>
                                {formik.touched.cart_calculation && formik.errors.cart_calculation ? (<label className="text-danger">{formik.errors.cart_calculation}</label>) : null}
                            </div>
                            <div className="col-md-12 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="visibility">Visibility <FaStarOfLife className='text-danger' /></label>
                                    <div className='my-3'>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" name="visibility" id="visibility" value="1" onChange={formik.handleChange} />
                                            <label className="form-check-label" htmlFor="visibility">Show only for logged in users</label>
                                        </div>
                                    </div>
                                </div>
                                {formik.touched.visibility && formik.errors.visibility ? (<label className="text-danger">{formik.errors.visibility}</label>) : null}
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6 col-12 d-flex gap-3">
                                <Link to={'/shippings'} type="submit" className="btn btn-dark cancel_btn">Cancel</Link>
                                <button type="submit" className="btn btn-primary submit_btn">Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    )
}

export default EditShippingMethod;